export class SourceMetaData {
    public __classname__: string = 'SourceMetaData';

    public Credit : string | null = null;

	public Source: string | null = null;

	public Author: string | null = null;

    constructor(params : SourceMetaDataNamedParameters) {
        this.Credit = params.Credit ?? null;
        this.Source = params.Source ?? null;
        this.Author = params.Author ?? null;
    }    
}

export interface SourceMetaDataNamedParameters{
    Credit? : string | null,
    Source? : string | null,
    Author? : string | null
}